import Vue from 'vue'
import './config/initializers'
import App from './App.vue'
import store from './store'
import i18n from '@/utils/i18n'
import { createProvider } from './utils/vue-apollo'
import linkify from 'vue-linkify'

Vue.directive('linkified', linkify)

Vue.store = store

new Vue({
  store,
  i18n,
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount('#app')
